<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <fieldset *ngIf="!editable" disabled style="border:none">
            <form [formGroup]="form" class="needs-validation" novalidate>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Operator de retea</label>
                  <input class="form-control" type="text" formControlName="operatorName" disabled>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>CLC<span>*</span></label>
                  <input class="form-control" type="text" formControlName="code">
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <h4> Adresa locului de consum</h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Judet<span>*</span></label>
                  <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                    <option *ngFor="let county of counties" [value]="county.id">
                      {{ county.name }} </option>
                  </select>
                </div>
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Localitate<span>*</span></label>
                  <select class="form-control digits" formControlName="city">
                    <option *ngFor="let city of cities" [value]="city.id">
                      {{ city.name }} </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Strada<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetName" required />
                  <div *ngIf="form.controls['streetName'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numele strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetNumber" required />
                  <div
                    *ngIf="form.controls['streetNumber'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numarul strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Bloc</label>
                  <input class="form-control" type="text" formControlName="block" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Etaj</label>
                  <input class="form-control" type="text" formControlName="floor" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Apartament</label>
                  <input class="form-control" type="text" formControlName="apartment" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Cod postal<span>*</span></label>
                  <input class="form-control" type="text" formControlName="postalCode" required />
                  <div *ngIf="form.controls['postalCode'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Codul postal este obligatoriu
                  </div>
                </div>
              </div>
              <br>
              <ng-container *ngIf="!editable">
                <div class="form-group row" *ngIf="false">
                  <div class="col-xl-4 col-md-4">
                    <label>Modul de contractare al serviciului de retea</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" disabled>
                      Prin furnizor
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" disabled>
                      Direct
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contract</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" [checked]="isNetworkTypeDistribution()">
                      Distributie
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" [checked]="isNetworkTypeTransport()">
                      Transport
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" [checked]="isNetworkTypeCA()">
                      Acces la conductele de alimentare din amonte
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Numar contract</label>
                    <input class="form-control" type="text" formControlName="contractNumber" disabled>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data contract</label>
                    <input class="form-control" type="date" formControlName="validFrom" onkeydown="return false"
                      disabled>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Exista conventie?</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isConvention" [checked]="isConventionPresent()">
                      DA
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isConvention" [checked]="!isConventionPresent()">
                      NU
                    </label>
                  </div>
                  <ng-container *ngIf="isConventionPresent()">
                    <div class="col-xl-4 col-md-4">
                      <label>Numar conventie</label>
                      <input class="form-control" type="text" formControlName="conventionNumber" disabled>
                    </div>
                    <div class="col-xl-4 col-md-4">
                      <label>Data conventie</label>
                      <input class="form-control" type="date" formControlName="conventionDate" onkeydown="return false"
                        disabled>
                    </div>
                  </ng-container>
                </div>
                <ng-container *ngIf="isConventionPresent()">
                  <div class="form-group row">
                    <div class="col-xl-2 col-md-2">
                      <label>Parti conventie</label>
                    </div>
                    <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                      <div *ngFor="let part of conventionParts" class="row">
                        <span class="list-item">{{part}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-xl-2 col-md-2">
                      <label class="d-block">
                        <input class="checkbox_animated" type="checkbox" disabled [checked]="suppliers.length > 1">
                        Exista mai multi furnizori
                      </label>
                    </div>
                    <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                      <div *ngFor="let supplier of suppliers" class="row">
                        <span class="list-item">{{supplier}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="connectionNotice">
                    Aviz tehnic de racordare<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.connectionNotice?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="connectionNoticeNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="connectionNoticeDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="accessAgreement">
                    Acord de acces<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.accessAgreement?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="accessAgreementNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="accessAgreementDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Exista un sistem de masurare inteligent<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="smartMeter" formControlName="smartMeter"
                      value='true' [checked]="this.form.value.smartMeter === true">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="smartMeter" formControlName="smartMeter"
                      value='false' [checked]="this.form.value.smartMeter === false">
                    NU
                  </label>
                </div>
                <ng-container>
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contor<span>*</span></label>
                    <select class="form-control digits" formControlName="counterType">
                      <option value="ACTIVE">ACTIV</option>
                      <option value="REACTIVE">REACTIV</option>
                      <option value="GAS">GAZ</option>
                      <option value="ACTIVE_REACTIVE">ACTIV_REACTIV</option>
                    </select>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Serie contor<span>*</span></label>
                    <input class="form-control" type="text" formControlName="counterSeries">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Status loc de consum<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="technicalDataStatus"
                      (click)="setTechnicalDataStatus('CONECTAT')" [checked]="isConsumptionPlaceConnected()">
                    Conectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="technicalDataStatus"
                      (click)="setTechnicalDataStatus('DECONECTAT')" [checked]="isConsumptionPlaceDisconnected()">
                    Deconectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="technicalDataStatus"
                      (click)="setTechnicalDataStatus('INACTIV')" [checked]="isConsumptionPlaceInactive()">
                    Inactiv
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="technicalDataStatus"
                      (click)="setTechnicalDataStatus('DEZAFECTAT')" [checked]="isConsumptionPlaceDezafectat()">
                    Inactiv
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Tip retea<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="networkType" (click)="setNetworkType('D')"
                      [checked]="isNetworkTypeDistribution()">
                    Distributie
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="networkType" (click)="setNetworkType('T')"
                      [checked]="isNetworkTypeTransport()">
                    Transport
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="networkType" (click)="setNetworkType('CA')"
                      [checked]="isNetworkTypeCA()">
                    Acces la conductele de alimentare din amonte
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Regim de functionare<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="operatingMode"
                      (click)="setOperatingMode('PERMANENT')" [checked]=isOperatingModePermanent()>
                    Permanent
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" value="SEZONIER" name="operatingMode"
                      (click)="setOperatingMode('SEZONIER')" [checked]=isOperatingModeSeasonal()>
                    Sezonier
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Categoria de consum<span>*</span></label>
                  <select class="form-control digits" formControlName="consumptionCategory">
                    <option value="C_1">C_1</option>
                    <option value="C_2">C_2</option>
                    <option value="C_3">C_3</option>
                    <option value="C_4">C_4</option>
                    <option value="C_5">C_5</option>
                    <option value="C_6">C_6 (Client cu consum anual mai mic sau egal cu 28.000 MWh)</option>
                    <option value="C_7">C_7 (Client cu consum anual de peste 28.000 MWh)</option>
                  </select>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Debit aprobat (mc/h)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="debit">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Capacitate rezervata (MWh/h)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="reservedCapacity">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Presiune cf. ATR (Pa)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="pressure">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Presiune minima (Pa)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="minimumPressure">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Presiune maxima (Pa)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="maximumPressure">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Presiune minima tehnologica (Pa)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="minimumTechnicalPressure">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Perioada citire index(luni)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="counterIndexInterval">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Descriere modalitate de completare index de la OR<span>*</span></label>
                  <textarea class="form-control"
                    placeholder="Trebuie sa completati valoare index multi-cadran: ex. 1.8.1:546|1.8.2:532|"
                    formControlName="counterIndexDesc"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Valoarea ultimului index citit</label>
                  <input class="form-control" type="number" formControlName="counterIndexValue">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Data ultimului index citit</label>
                  <input class="form-control" type="date" formControlName="counterIndexReadDate"
                    onkeydown="return false">
                </div>
              </div>
            </form>
          </fieldset>
          <br>
          <div class="form-group row mb-0 pull-right">
            <div class="col-xl-auto col-md-auto">
              <button *ngIf="!editable" [routerLink]="'..'" type="button" class="btn btn-light button-margin">Renunta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
